import { useFeatureFlagEnabled } from '@frameio/feature-flags';
import { useIsNLPEnabled } from '../../shared/hooks';

export type ListMode = 'SINGLE' | 'MULTI' | 'MULTI_TABBED';

export const useQuickSearchListMode = () => {
  const isNlpEnabled = useIsNLPEnabled();
  const isTabbedViewEnabled = useFeatureFlagEnabled(
    'v4.quick_search_tabbed_view'
  );
  let listMode: ListMode = 'SINGLE';
  if (isNlpEnabled) {
    listMode = isTabbedViewEnabled ? 'MULTI_TABBED' : 'MULTI';
  }

  return { listMode };
};
